module.exports = __webpack_public_path__ + "static/media/matnrrd_3-273w.3e8b4dcf.png";